'use client';

import { Flex, Heading, Text } from '@/_components';
import { useContext, type FC } from 'react';
import { UserContext } from '@/_contexts/UserProvider';
import { UserPreviewContext } from '@/_contexts/admin/UserPreviewProvider';
import styles from './AllDoneDashboard.module.css';
interface AllDoneDashboardProps {
  isPreview?: boolean;
  selectedYear?: string;
}

export const AllDoneDashboard: FC<AllDoneDashboardProps> = ({
  isPreview = false,
  selectedYear,
}) => {
  const { company } = useContext(UserContext);
  const { previewCompany } = useContext(UserPreviewContext);

  const currentCompany = isPreview ? previewCompany : company;
  const entityName = currentCompany?.name || 'this entity';

  return (
    <Flex isColumn={true} gap={16} isYCentered={true} padding={32}>
      <Flex className={styles.allDoneDashboardImage}>
        <img
          src="/images/enterprise/SentEnterpriseFormIllustration.png"
          alt="Paper illustration depicting confirmed request"
        />
      </Flex>
      <Flex isColumn={true} gap={8} isYCentered={true}>
        <Heading level={4} color="success">
          All Done for {selectedYear || 'this year'}
        </Heading>
        <Text type="small" color="secondary" textAlign="center">
          You&apos;ve completed all tasks for {entityName}.
        </Text>
      </Flex>
    </Flex>
  );
};
